import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d39604a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"8px","margin-left":"10px"} }
const _hoisted_3 = {
  key: 0,
  class: "query-result-area"
}
const _hoisted_4 = { class: "gps-inputs" }
const _hoisted_5 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","gap":"8px","margin-left":"10px"} }
const _hoisted_8 = {
  key: 0,
  class: "query-result-area"
}
const _hoisted_9 = { style: {"display":"flex","align-items":"center","gap":"8px","margin-left":"10px"} }
const _hoisted_10 = {
  key: 0,
  class: "query-result-area"
}
const _hoisted_11 = { style: {"display":"flex","align-items":"center","gap":"8px","margin-left":"10px"} }
const _hoisted_12 = {
  key: 0,
  class: "query-result-area"
}
const _hoisted_13 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center","gap":"8px","margin-left":"10px"} }
const _hoisted_15 = {
  key: 0,
  class: "query-result-area"
}
const _hoisted_16 = {
  key: 1,
  class: "remark-area",
  style: {"margin-top":"16px","padding":"12px","background-color":"#fff5f5","border-radius":"4px"}
}
const _hoisted_17 = { style: {"display":"flex","align-items":"flex-start"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff4d4f","font-weight":"bold","margin-right":"4px"} }, "备注:", -1))
const _hoisted_19 = { style: {"color":"#333","font-size":"12px","line-height":"1.5"} }
const _hoisted_20 = { class: "dialog-footer" }

import {ref, reactive, computed, watch, onMounted, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { getListCompanyInfo } from "@/views/Login/api";
import {getCorrectionData,correct  } from '../api.js'
import {Search} from "@element-plus/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDataCorrDialog',
  props: {
    visible: { type: Boolean }
  },
  emits: ['update:visible', 'created'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  visible: boolean
};





const dialogVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value)
});
const talentArr = ref<any>([]);
// 地址选项列表
const addressOptions = ref<Array<{value: string, label: string, longitude?: string, latitude?: string}>>([]);

// 表单数据
const form = reactive({
  dataCorrectionType: '',
  compCode: '',

  // 地址修正相关
  queryType:'ORDER',
  orderCaseNo: '',
  address: '',//带出
  currentGPS: '',//带出
  correctAddress: '',
  correctLongitude: '',
  correctLatitude: '',
  correctCoordinates:'',

  //数据推送状态修正
  policyNo:'',
  orderNo:'',
  caseNo:'',
  pushResult:'',
  currentPushResult:'WAIT_PUSH',//带出

  // 姓名/证件修正相关
  idCard: '',
  currentName: '',//带出
  correctName: '',
  correctIdCard: '',

  // 登记号相关
  targetNo: '',
  currentRegisterNo: '',//带出
  correctRegisterNo: '',
  earNo:'',//带出
  collarBarcode:'',//带出

  //带出
  policyId:null,
  orderId:null,
  caseId:null,
  targetId:null,
  farmerId:null,
});

// 表单引用
const formRef = ref();

// 表单验证规则
const formRules = {
  dataCorrectionType: [{ required: true, message: '请选择修正数据类型', trigger: 'change' }],
  compCode: [{ required: true, message: '请选择租户', trigger: 'change' }],
  orderCaseNo: [{ required: true, message: '请输入采集订单号/案件号', trigger: 'blur' }],
  idCard: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
  targetNo:[{required: true, message: '请输入标的号', trigger: 'blur' }],
  correctAddress: [{ required: true, message: '请选择或输入更正地址', trigger: 'change' }],
  pushResult: [{ required: true, message: '请选择修正数据状态', trigger: 'change' }],
  correctName: [{ required: true, message: '请输入更正姓名', trigger: 'blur' }],
  correctRegisterNo: [{ required: true, message: '请输入更正登记号', trigger: 'blur' }],

  // 添加其他字段的验证规则...
};

// 清除所有验证
const clearAllValidations = () => {
  nextTick(() => {
    if (formRef.value) {
      formRef.value.clearValidate();
    }
  });
};
// 暴露给父组件的方法
expose({
  clearAllValidations
});
onMounted(() => {
  getListCompanyInfos();
});
// 是否显示查询结果
const showQueryResult = ref(false);
// 选择器引用
const selectRef = ref();

// 监听修正类型变化
const handleTypeChange = () => {
  // 切换类型时重置查询结果
  showQueryResult.value = false;
  addressOptions.value = [];
  resetFormFields();
  clearAllValidations();
};
const getListCompanyInfos = () => {
  getListCompanyInfo().then((res: any) => {
    console.log(res);
    talentArr.value = res;
  });
};
// 当前地址选择变化
const handleAddressChange = (address: string) => {
  if (address) {
    const selectedAddress = addressOptions.value.find(addr => addr.value === address);
    if (selectedAddress && selectedAddress.longitude && selectedAddress.latitude) {
      form.currentGPS = `${selectedAddress.longitude}, ${selectedAddress.latitude}`;
    }
  } else {
    form.currentGPS = '';
  }
};

// 更正地址选择变化
const handleCorrectAddressChange = (address: string) => {
  if (address) {
    const selectedAddress = addressOptions.value.find(addr => addr.value === address);
    if (selectedAddress && selectedAddress.longitude && selectedAddress.latitude) {
      form.correctLongitude = selectedAddress.longitude;
      form.correctLatitude = selectedAddress.latitude;
      form.correctCoordinates = `${selectedAddress.longitude}, ${selectedAddress.latitude}`;
    } else {
      // 如果是手动输入的新地址，清空GPS
      form.correctLongitude = '';
      form.correctLatitude = '';
      form.correctCoordinates = '';
    }
  } else {
    form.correctLongitude = '';
    form.correctLatitude = '';
    form.correctCoordinates = '';
  }
};
// 重置表单字段
const resetFormFields = () => {
  form.compCode = '';
  form.queryType = 'ORDER';
  form.orderCaseNo = '';
  form.targetNo = '';
  form.idCard = '';
  form.address = '';
  form.currentGPS = '';
  form.correctAddress = '';
  form.correctLongitude = '';
  form.correctLatitude = '';
  form.correctCoordinates = '';
  form.currentName = '';
  form.correctName = '';
  form.correctIdCard = '';
  form.currentRegisterNo = '';
  form.correctRegisterNo = '';
  form.earNo = '';
  form.collarBarcode = '';
  form.currentPushResult = '';
  form.pushResult = '';
  form.policyNo = '';
  form.orderNo = '';
  form.targetNo = '';
  form.caseNo = '';
  form.policyId = null;
  form.orderId = null;
  form.caseId = null;
  form.targetId = null;
  form.farmerId = null;
  addressOptions.value = [];
};

// 查询按钮点击
// 查询按钮点击
const handleQuery = async () => {
    // 验证必填字段
    if (!form.dataCorrectionType) {
      ElMessage.warning('请先选择修正数据类型');
      return;
    }

    if (!form.compCode) {
      ElMessage.warning('请先选择租户');
      return;
    }

    // 构建查询参数
    const queryParams: any = {
      compCode: form.compCode,
      dataCorrectionType: form.dataCorrectionType
    };

    // 根据不同修正类型添加参数
    switch(form.dataCorrectionType) {
      case 'ADDRESS':
        if (!form.orderCaseNo) {
          ElMessage.warning(form.queryType === 'ORDER' ? '请输入采集订单号' : '请输入案件号');
          return;
        }
        queryParams.orderNo = form.queryType === 'ORDER' ? form.orderCaseNo : undefined;
        queryParams.caseNo = form.queryType === 'CASE' ? form.orderCaseNo : undefined;
        break;

      case 'PUSH_STATUS':
        if (!form.policyNo && !form.caseNo) {
          ElMessage.warning('请输入保单号或案件号');
          return;
        }
        queryParams.caseNo = form.caseNo;
        queryParams.policyNo = form.policyNo;
        break;

      case 'FARMER_NAME':
      case 'IDCARD':
        if (!form.idCard) {
          ElMessage.warning('请输入证件号码');
          return;
        }
        queryParams.idCard = form.idCard;
        break;

      case 'REGISTER_NO':
        if (!form.orderCaseNo) {
          ElMessage.warning(form.queryType === 'ORDER' ? '请输入采集订单号' : '请输入案件号');
          return;
        }
        if (!form.targetNo) {
          ElMessage.warning('请输入标的号');
          return;
        }
        queryParams.orderNo = form.queryType === 'ORDER' ? form.orderCaseNo : undefined;
        queryParams.caseNo = form.queryType === 'CASE' ? form.orderCaseNo : undefined;
        queryParams.targetNo = form.targetNo;
        break;
    }
  console.log('查询条件', queryParams)
    // 这里应该调用API查询数据
    getCorrectionData(queryParams)
        .then(res => {
          console.log(res)
          if (res.length === 0) {
            ElMessage.warning('未查询到数据')
          } else if (res.length > 0) {
            showQueryResult.value = true;

            let data = res[0]
            form.orderId = data.orderId || null;
            form.caseId = data.caseId || null;
            form.targetId = data.targetId || null;
            form.farmerId = data.farmerId || null;
            form.policyId = data.policyId || null;
            if (form.dataCorrectionType === 'ADDRESS') {
              const addresses = res || [];
              addressOptions.value = addresses.map((addr: any, index: number) => {
                let longitude = '';
                let latitude = '';

                if (addr.coordinates) {
                  // 分割经纬度字符串
                  const gpsParts = addr.coordinates.split(',');
                  if (gpsParts.length >= 2) {
                    longitude = gpsParts[0].trim();
                    latitude = gpsParts[1].trim();
                  }
                }

                return {
                  value: addr.address,
                  label: addr.address,
                  longitude: longitude,
                  latitude: latitude
                };
              });

              // 如果有地址，默认选择第一个
              if (addressOptions.value.length > 0) {
                form.address = addressOptions.value[0].value;

                // 设置当前GPS
                if (addressOptions.value[0].longitude && addressOptions.value[0].latitude) {
                  form.currentGPS = `${addressOptions.value[0].longitude}, ${addressOptions.value[0].latitude}`;
                } else if (addresses[0]?.gps) {
                  // 如果直接从原数据获取gps
                  form.currentGPS = addresses[0].gps;
                }

                // 默认更正地址也为第一个
                form.correctAddress = addressOptions.value[0].value;
                form.correctLongitude = addressOptions.value[0].longitude || '';
                form.correctLatitude = addressOptions.value[0].latitude || '';
                form.correctCoordinates = addressOptions.value[0].coordinates || '';
              }
            } else {
              if (form.dataCorrectionType === 'PUSH_STATUS') {
                // 数据推送状态相关字段
                form.currentPushResult = data.pushResult || 'WAIT_PUSH';
                form.pushResult = 'WAIT_PUSH'; // 默认待推送
              } else if (form.dataCorrectionType === 'FARMER_NAME') {
                // 姓名修正相关字段
                form.currentName = data.farmerName || '';
                form.idCard = data.idCard || form.idCard; // 保留用户输入的证件号
              } else if (form.dataCorrectionType === 'IDCARD') {
                // 证件修正相关字段
                form.currentName = data.farmerName || '';
                form.idCard = data.idCard || form.idCard; // 保留用户输入的证件号
              } else if (form.dataCorrectionType === 'REGISTER_NO') {
                // 登记号修正相关字段
                form.currentRegisterNo = data.earNo || data.collarBarcode || '';
                form.earNo = data.earNo || '';
                form.collarBarcode = data.collarBarcode || '';
              }
            }
          }

          // ElMessage.success('查询成功');
        })
        .catch(error => {
          // ElMessage.error('查询失败');
          console.error('查询错误:', error);
        });
};

// 确定按钮点击
const handleSubmit = async () => {
  if (!form.dataCorrectionType) {
    ElMessage.warning('请选择修正数据类型');
    return;
  }

  if (!form.compCode) {
    ElMessage.warning('请选择租户');
    return;
  }

  if (!showQueryResult.value) {
    ElMessage.warning('请先查询数据');
    return;
  }

  // 验证修正字段
  let isValid = true;
  let errorMsg = '';

  if (form.dataCorrectionType === 'ADDRESS') {
    if (!form.correctAddress) {
      isValid = false;
      errorMsg = '请输入更正地址';
    }
    if (!form.correctLongitude || !form.correctLatitude) {
      isValid = false;
      errorMsg = '请输入更正经纬度'
    }
  } else if (form.dataCorrectionType === 'FARMER_NAME') {
    if (!form.correctName) {
      isValid = false;
      errorMsg = '请输入修正姓名';
    }
  } else if (form.dataCorrectionType === 'IDCARD') {
    if (!form.correctIdCard) {
      isValid = false;
      errorMsg = '请输入修正证件号码';
    }
  } else if (['REGISTER_NO'].includes(form.dataCorrectionType)) {
    if (!form.correctRegisterNo) {
      isValid = false;
      errorMsg = '请输入修正登记号';
    }
  }

  if (!isValid) {
    ElMessage.warning(errorMsg);
    return;
  }

  // 构建查询参数
  const queryParams: any = {
    compCode: form.compCode,
    dataCorrectionType: form.dataCorrectionType,
    policyId: form.policyId,
    caseId: form.caseId,
    orderId: form.orderId,
    targetId: form.targetId,
    farmerId: form.farmerId,
  };
  // 根据不同修正类型添加参数
  switch(form.dataCorrectionType) {
    case 'ADDRESS':
      queryParams.address = form.address;
      queryParams.correctAddress = form.correctAddress;
      queryParams.correctCoordinates = `${form.correctLongitude}, ${form.correctLatitude}`;
      queryParams.orderNo = form.queryType === 'ORDER' ? form.orderCaseNo : null;
      queryParams.caseNo = form.queryType === 'CASE' ? form.orderCaseNo : null;
      break
    case 'FARMER_NAME':
      queryParams.farmerName = form.correctName;
      break
    case 'IDCARD':
      queryParams.idCard = form.correctIdCard;
      break
    case 'REGISTER_NO':
      if (form.collarBarcode) {
        queryParams.collarBarcode = form.correctRegisterNo;
      } else {
        queryParams.earNo = form.correctRegisterNo;
      }
      queryParams.targetNo = form.targetNo;
      queryParams.orderNo = form.queryType === 'ORDER' ? form.orderCaseNo : null;
      queryParams.caseNo = form.queryType === 'CASE' ? form.orderCaseNo : null;
      break
    case 'PUSH_STATUS':
      queryParams.pushResult = form.pushResult;
      queryParams.policyNo = form.policyNo;
      queryParams.caseNo = form.caseNo;
      break
  }
  try {
    console.log('提交数据', queryParams)
    await correct(queryParams);

    handleClose();
    emit('created'); // 通知父组件数据已创建/更新
  } catch (error) {
    console.error('提交错误:', error);
  }
};

// 关闭弹窗
const handleClose = () => {
  // 重置表单
  resetFormFields();
  form.dataCorrectionType = '';
  form.compCode = '';
  showQueryResult.value = false;
  clearAllValidations();
  dialogVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "数据修正",
    modelValue: _unref(dialogVisible),
    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
    width: "30%",
    "close-on-click-modal": false,
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_20, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form,
        rules: formRules,
        "label-width": "auto",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "修正数据类型",
            prop: "dataCorrectionType",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                ref_key: "selectRef",
                ref: selectRef,
                modelValue: form.dataCorrectionType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.dataCorrectionType) = $event)),
                placeholder: "请选择",
                clearable: "",
                onChange: handleTypeChange,
                style: {"width":"280px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "地址",
                    value: "ADDRESS"
                  }),
                  _createVNode(_component_el_option, {
                    label: "推送状态",
                    value: "PUSH_STATUS"
                  }),
                  _createVNode(_component_el_option, {
                    label: "证件号码",
                    value: "IDCARD"
                  }),
                  _createVNode(_component_el_option, {
                    label: "农户姓名",
                    value: "FARMER_NAME"
                  }),
                  _createVNode(_component_el_option, {
                    label: "登记号",
                    value: "REGISTER_NO"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "租户",
            prop: "compCode",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.compCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.compCode) = $event)),
                placeholder: "请选择",
                style: {"width":"280px"},
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(talentArr.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.compCode,
                      label: item.compName,
                      value: item.compCode
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (form.dataCorrectionType === 'ADDRESS')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_form_item, {
                  label: "采集订单号/案件号",
                  prop: "queryType",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: form.queryType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.queryType) = $event)),
                      size: "small",
                      style: {"margin-right":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: "ORDER" }, {
                          default: _withCtx(() => [
                            _createTextVNode("采集订单号")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "CASE" }, {
                          default: _withCtx(() => [
                            _createTextVNode("案件号")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "采集订单号/案件号",
                  prop: "orderCaseNo",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_el_input, {
                        modelValue: form.orderCaseNo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.orderCaseNo) = $event)),
                        placeholder: "请输入",
                        clearable: "",
                        style: {"flex":"1","width":"280px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_button, {
                        icon: _unref(Search),
                        onClick: handleQuery
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }),
                (showQueryResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, { label: "当前地址" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: form.address,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.address) = $event)),
                            placeholder: "请选择当前地址",
                            clearable: "",
                            filterable: "",
                            style: {"width":"280px"},
                            onChange: handleAddressChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressOptions.value, (address) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: address.value,
                                  label: address.label,
                                  value: address.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "GPS" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.currentGPS,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.currentGPS) = $event)),
                            readonly: true,
                            placeholder: "选择地址后显示GPS",
                            style: {"width":"280px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "更正地址",
                        prop: "correctAddress",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: form.correctAddress,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.correctAddress) = $event)),
                            placeholder: "请选择或输入地址",
                            clearable: "",
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            style: {"width":"280px"},
                            onChange: handleCorrectAddressChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressOptions.value, (address) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: address.value,
                                  label: address.label,
                                  value: address.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "GPS" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_el_input, {
                              modelValue: form.correctLongitude,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.correctLongitude) = $event)),
                              placeholder: "请输入经度",
                              style: {"flex":"1","margin-right":"8px"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_input, {
                              modelValue: form.correctLatitude,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.correctLatitude) = $event)),
                              placeholder: "请输入纬度",
                              style: {"flex":"1"}
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (form.dataCorrectionType === 'PUSH_STATUS')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_form_item, {
                  label: "保单号",
                  prop: "policyNo"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_input, {
                        modelValue: form.policyNo,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.policyNo) = $event)),
                        placeholder: "请输入保单号",
                        clearable: "",
                        style: {"flex":"1","width":"280px"}
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "案件号" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_input, {
                        modelValue: form.caseNo,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.caseNo) = $event)),
                        placeholder: "请输入案件号",
                        clearable: "",
                        style: {"flex":"1","width":"280px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_button, {
                        icon: _unref(Search),
                        onClick: handleQuery
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }),
                (showQueryResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_el_form_item, { label: "当前数据状态" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            ref_key: "selectRef",
                            ref: selectRef,
                            modelValue: form.currentPushResult,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.currentPushResult) = $event)),
                            disabled: "",
                            placeholder: "根据查询结果带出",
                            style: {"width":"280px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "推送异常",
                                value: "EXCEPTION_PUSH"
                              }),
                              _createVNode(_component_el_option, {
                                label: "推送成功",
                                value: "SUCCESS_PUSH"
                              }),
                              _createVNode(_component_el_option, {
                                label: "数据处理中",
                                value: "HANDLE_DATA"
                              }),
                              _createVNode(_component_el_option, {
                                label: "数据处理异常",
                                value: "EXCEPTION_DATA"
                              }),
                              _createVNode(_component_el_option, {
                                label: "推送中",
                                value: "HANDLE_PUSH"
                              }),
                              _createVNode(_component_el_option, {
                                label: "数据处理完成",
                                value: "SUCCESS_DATA"
                              }),
                              _createVNode(_component_el_option, {
                                label: "待推送",
                                value: "WAIT_PUSH"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "修正数据状态为",
                        prop: "pushResult",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            ref_key: "selectRef",
                            ref: selectRef,
                            modelValue: form.pushResult,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.pushResult) = $event)),
                            placeholder: "请选择",
                            clearable: "",
                            style: {"width":"280px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "待推送",
                                value: "WAIT_PUSH"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (form.dataCorrectionType === 'FARMER_NAME')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_el_form_item, {
                  label: "证件号码",
                  prop: "idCard",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.idCard,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.idCard) = $event)),
                      placeholder: "请输入证件号码",
                      clearable: "",
                      style: {"flex":"1","width":"280px"}
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_button, {
                        icon: _unref(Search),
                        onClick: handleQuery
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }),
                (showQueryResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_el_form_item, { label: "当前姓名" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.currentName,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.currentName) = $event)),
                            readonly: true,
                            placeholder: "根据查询结果带出",
                            style: {"width":"280px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "修正姓名为",
                        prop: "correctName",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.correctName,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.correctName) = $event)),
                            placeholder: "请输入姓名",
                            style: {"width":"280px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (form.dataCorrectionType === 'IDCARD')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_el_form_item, {
                  label: "证件号码",
                  prop: "idCard",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.idCard,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.idCard) = $event)),
                      placeholder: "请输入证件号码",
                      clearable: "",
                      style: {"width":"280px"}
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        icon: _unref(Search),
                        onClick: handleQuery
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }),
                (showQueryResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_el_form_item, { label: "当前姓名" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.currentName,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.currentName) = $event)),
                            readonly: true,
                            placeholder: "根据查询结果带出",
                            style: {"width":"280px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "修正证件号码为",
                        prop: "correctIdCard",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.correctIdCard,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.correctIdCard) = $event)),
                            placeholder: "请输入新的证件号码",
                            style: {"width":"280px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (['REGISTER_NO'].includes(form.dataCorrectionType))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(_component_el_form_item, {
                  label: "采集订单号/案件号",
                  prop: "queryType",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: form.queryType,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.queryType) = $event)),
                      size: "small",
                      style: {"margin-right":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, { label: "ORDER" }, {
                          default: _withCtx(() => [
                            _createTextVNode("采集订单号")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, { label: "CASE" }, {
                          default: _withCtx(() => [
                            _createTextVNode("案件号")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "采集订单号/案件号",
                  prop: "orderCaseNo",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_input, {
                        modelValue: form.orderCaseNo,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.orderCaseNo) = $event)),
                        placeholder: "请输入",
                        clearable: "",
                        style: {"flex":"1","width":"280px"}
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "标的号",
                  prop: "targetNo",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.targetNo,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.targetNo) = $event)),
                      placeholder: "请输入",
                      clearable: "",
                      style: {"width":"280px"}
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_el_button, {
                        icon: _unref(Search),
                        onClick: handleQuery
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }),
                (showQueryResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_el_form_item, { label: "当前登记号" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.currentRegisterNo,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.currentRegisterNo) = $event)),
                            readonly: true,
                            placeholder: `根据${form.dataCorrectionType === 'REGISTER_NO' ? '采集订单' : '采样订单号'}的标的号查询登记号`,
                            style: {"width":"280px"}
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: `修正${form.dataCorrectionType === 'REGISTER_NO' ? '登记号' : '登记号'}为`,
                        prop: "correctRegisterNo",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.correctRegisterNo,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.correctRegisterNo) = $event)),
                            placeholder: `请输入${form.dataCorrectionType === 'REGISTER_NO' ? '新登记号' : '承保登记号'}`,
                            style: {"width":"280px"}
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true),
                (showQueryResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("span", _hoisted_19, [
                          (form.queryType === 'ORDER')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" 查询采集订单下标的号对应的耳标号，输入新增修正登记号对已存在的登记号进行修正。修正登记号与租户内登记号不得重复。 ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" 案件号的当前登记号需已存在案件中，修正登记号需在案件对应的保单内存在。 ")
                              ], 64))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})